
import { defineComponent } from "vue";
import { IComponentsNavigationBarConfig, IScheduleRun, IScheduleTeam } from "../types";
import CustomSelect from "../components/inputs/CustomSelect.vue";
import KeyValueRow from "../components/layout/KeyValueRow.vue";
import Card from "../components/layout/Card.vue";
import EditIcon from "../components/icons/EditIcon.vue";
import CheckmarkIcon from "../components/icons/CheckmarkIcon.vue";
import WarningIcon from "../components/icons/WarningIcon.vue";

import { competitionIdToReadableName, convertDateToString, parseServerScheduleTimestamp } from "../helpers/formatting";

export default defineComponent({
  name: "Run2Team",
  components: { CustomSelect, KeyValueRow, Card, EditIcon, CheckmarkIcon, WarningIcon },
  data() {
    return {};
  },
  computed: {
    teamOptions(): Array<{ text: string; value: string }> {
      interface RunToIncluded extends IScheduleRun {
        parsedTime: number;
        teamname: string;
      }
      const runsToBeIncluded: RunToIncluded[] = [];
      for (const run of this.$store.state.schedule.runs as IScheduleRun[]) {
        if (
          run.competition === this.$store.state.currentRun.competition &&
          run.arenaId === this.$store.state.currentRun.arenaId &&
          run.round === this.$store.state.currentRun.round
        ) {
          runsToBeIncluded.push({
            ...run,
            parsedTime: parseServerScheduleTimestamp(run.time).getTime(),
            teamname: ((this.$store.state.schedule.teams as IScheduleTeam[]).find((team) => team.teamId === run.teamId) || { name: "" })
              .name,
          });
        }
      }
      // order runs by time
      runsToBeIncluded.sort((runA, runB) => {
        return runA.parsedTime - runB.parsedTime;
      });
      return runsToBeIncluded.map((run) => ({
        text: convertDateToString(new Date(run.parsedTime), "hh:mm") + " " + run.teamname,
        value: run.teamId, // TODO: use runId?
      }));
    },
    competitionName(): string {
      return competitionIdToReadableName(this.$store.state.currentRun.competition || "");
    },
  },
  methods: {
    tc(key: string): string {
      return this.$t("run.team." + key);
    },
    tg(key: string): string {
      return this.$t("general." + key);
    },
    getNavigationBarConfig(): IComponentsNavigationBarConfig {
      return {
        disableDrawerSwipeGestures: false,
        backButtonInsteadOfDrawer: false,
      };
    },
    backToSetup(): void {
      this.$router.push("/run/setup");
    },
    goToLogin(): void {
      this.$router.push("/login");
    },
    setTeam(teamId: string): void {
      this.$store.commit("setTeam", teamId);
      // TODO: ask whether scoring data should be resetted or not
    },
    continueToPreRun(): void {
      if (
        this.$store.state.currentRun.competition &&
        this.$store.state.currentRun.arenaId &&
        this.$store.state.currentRun.round &&
        this.$store.state.currentRun.teamId
      ) {
        this.$router.push("/run/prerun");
      }
    },
  },
  mounted() {
    if (!(this.$store.state.currentRun.competition && this.$store.state.currentRun.arenaId && this.$store.state.currentRun.round)) {
      this.$router.push("/run/setup");
    }
  },
});
